import React from "react";
import { PhotoColumn } from "../../components/photo-column";

import SaferDal2 from '../../assets/photos/hakkimizda/safer-efendi-grey.jpg';

export const SeferDal = () => {
    return (
        <div>
            <PhotoColumn
                imageSource={SaferDal2}
                imageTitle="Safer Dal"
                figcaptionFirstTitle="Safer Dal (1926-1999)"
                figcaptionSecondTitle="Halvetî-Cerrâhî Şeyhi"
            />

            <article>
                <h2 className="title">Safer Dal Efendi</h2>

                <p>
                    1985’te Muzaffer Ozak’ın vefatı üzerine Nûreddin Cerrâhî Tekkesi’nin yirminci türbedarı ve postnişini olarak
                    irşad görevine başladı. Türk Tasavvuf Mûsikisi ve Folklorunu Araştırma ve Yaşatma Vakfı’nın başkanlığını
                    üstlendi. Pazartesi ve perşembe akşamları meşk ve zikir icra eden, cumartesi akşamlarını sadece sohbete ayıran
                    Safer Dal âyet ve hadislerin yorumu diye nitelediği evliya sözleri, nutukları ve menkıbelerinden örneklerle
                    zenginleştirdiği sohbetlerinde tasavvufun en ince meselelerini sade bir dille anlattı. Sohbetlerindeki
                    muhabbetli, zarif ve mütevazi tavrı yerli ve yabancı her kesimden pek çok kimsenin kendisine intisabını
                    sağladı. Ona göre tasavvuf irfanı ve dervişlik sırrı Hakk’a muhabbetle kullukta ve mahlûkata şefkatle hizmette
                    gizlidir.
                </p>
                <p>
                    Tekke mûsikisini çok iyi bilen Fahreddin Efendi’ye intisabının ardından mûsikiyle de ilgilenmeye başladı.
                    Cerrâhî Âsitânesi zâkirbaşılarından sertarik Ali Haydar Efendi, Albay Selâhattin Gürer, Hopçuzâde Şakir Efendi
                    (Çetiner), Hüseyin Sebilci (Okurlar), Selâhattin Demirtaş, Yarbay Zühtü Bey, Necati Bey, Hâfız Hüseyin Tolan,
                    Hâfız Yaşar Okur, Hâfız Asım Bey gibi bestekâr ve mûsikişinaslarla tanıştı. Bunların bestelerini kendi
                    seslerinden makara teyplere kaydederek pek çok eseri kaybolmaktan kurtardı. 1980’li yıllarda tanıştığı Kanûnî
                    Cüneyt Kosal ve Metin Alkanlı’ya arşivlediği ses kayıtlarını verip bu eserlerin notaya alınmasını sağladı.
                    Türk Tasavvuf Mûsikisi ve Folklorunu Araştırma ve Yaşatma Vakfı’nda notaya alınan eserleri eski İstanbul
                    tekkelerinde icra edilen zikir usulleriyle meşkettirerek yeni nesillere öğretti. Bu meşkler sırasında Cüneyt
                    Kosal, Zeki Altun, Doğan Ergin, Arslan Hepgür, Metin Alkanlı, Sami Savni Özer ve Ahmet Muhtar Gölge gibi
                    müzisyenleri bizzat kendisi güfte vererek bestekârlığa teşvik etti. Günümüzde eser ve icra bakımından hayli
                    zengin durumda olan tekke mûsikisi kültürü bunu büyük ölçüde Safer Dal’ın gayretlerine borçludur. Mûsikiye
                    katkıları arasında kendi dokuz bestesini de zikretmek gerekir. Bunların en meşhuru Fahreddin Efendi’nin,
                    “Tevhid etsin dilimiz” nutkuna yaptığı hüseynî bestedir. Safer Dal tekke kültürü hakkında da geniş bilgi
                    sahibiydi. Bu konularla ilgili araştırmacı ve akademisyenlere cömertçe yardımlarda bulundu, hayatını kaybolan
                    tasavvuf kültürünü canlandırma yoluna adadı. Ayrıca yurt içi ve yurt dışındaki evliya türbelerine tarikatı
                    belirten tâc-ı şerif koyarak ve sandukaları yenileyerek hizmette bulunan Safer Dal, 21 Şubat 1999 tarihinde
                    vefat etti ve Nûreddin Cerrâhî Dergâhı Türbesi’ne defnedildi.
                </p>
                <p>
                    Sıddık Safer Efendi ile hamdolsun esmamızı ikmal ettik. Mürşid-i Azizimizin Himmetleriyle sema meşki yaptık.
                    Safer Efendi bana “Senin dünyanın her tarafından dervişin var. Bu çok güzel bir şeydir.” derdi.
                    Zaman zaman da “Fatih’teki Malta Çarşısı’nda dergahını açarsın.” derdi. Fakat Fakirin de hiç aklından böyle bir şey geçmiyordu.
                    Demek ki Efendi manevi olarak görüyormuş. Kaderimizde varmış. Hamdolsun dergahımızı açtık.
                    Bugüne kadar 400’ün üzerinde kişi İslam ile müşerref oldu. Elhamdulillah.
                </p>
                <p>
                    Cuma günleri dergâhta Halvetî Cerrahî usulünde zikir yapıyoruz. Pazar günleri ise  Sema meşkinde bulunuyoruz.
                    Mürşidi Azizlerimizin bize sunmuş olduğu bilgiler ile yurt içinde ve yurt dışında yeni ufuklar açmaya çalışıyoruz.
                    Allah cümlemizi hayırlı işlere vesile kılsın.
                </p>
            </article>
        </div>
    );
}